import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.modals;

export const modals = createSelector([selector], (state) => state.modals);
export const toastNotificationPopUp = createSelector([selector], (state) => state.toastNotificationPopUp);

export default {
  modals,
  toastNotificationPopUp
};
